import {
  Select as BaseSelect,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';

interface SelectProps {
  options: string[];
  placeholder?: string;
  selected: string | undefined;
  disabled?: boolean;
  allowAllOption?: boolean;
  onSelect: (value: string | undefined) => void;
  className?: string;
  /** Accessible name for the trigger (tests and screen readers). */
  'aria-label'?: string;
}

//TODO: remove all option from component

export const Select = ({
  options,
  placeholder,
  disabled,
  selected,
  allowAllOption = true,
  onSelect,
  className,
  'aria-label': ariaLabel,
}: SelectProps) => {
  return (
    <BaseSelect
      disabled={disabled}
      value={selected}
      onValueChange={(value) => {
        // Only treat 'none' as special if it's the "All" option (allowAllOption is true)
        // and 'none' is not in the actual options array
        if (value === 'none' && allowAllOption && !options.includes('none')) {
          onSelect(undefined);
        } else {
          onSelect(value);
        }
      }}
    >
      <SelectTrigger
        className={className || 'w-[200px] h-auto'}
        aria-label={ariaLabel}
      >
        <SelectValue placeholder={placeholder} />
      </SelectTrigger>
      <SelectContent>
        {allowAllOption && selected && (
          <SelectItem value={'none'}>All</SelectItem>
        )}
        {options.map((name: string, i: number) => (
          <SelectItem value={name} key={`${name}-${i}`}>
            {name}
          </SelectItem>
        ))}
      </SelectContent>
    </BaseSelect>
  );
};
